export class UserSettings {
  public static markerSize = 1;
}
